import { combineLatest, Observable } from 'rxjs'
import { nvDataObservable } from './nvData'
import { shopifyDataObservable } from './shopifyData'
import { mapLinkingStep } from './transformers'

export const routeObservable: Observable<string> = combineLatest(
  nvDataObservable,
  shopifyDataObservable
).pipe(mapLinkingStep)
